module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAsideMenu),
      expression: "isShowAsideMenu"
    }],
    staticClass: "aside-menu"
  }, [_c('div', {
    staticClass: "menu",
    style: ({
      background: _vm.skinColor
    })
  }, [_c('div', {
    staticClass: "user"
  }, [_c('Close', {
    on: {
      "close": _vm.hiddenAsideMenu
    }
  }), _vm._v(" "), _c('Buttons', {
    staticClass: "user-avatar",
    on: {
      "click": _vm.showLogin
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo ? _vm.userInfo.avatar_url : ''
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_vm._v("\n                      " + _vm._s(_vm.userInfo.success ? _vm.userInfo.loginname : '点击头像登录') + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('Buttons', {
    staticClass: "option",
    on: {
      "click": _vm.showMsg
    }
  }, [_c('i', {
    staticClass: "fa fa-volume-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "option-text"
  }, [_vm._v("我的消息")])]), _vm._v(" "), _c('Buttons', {
    staticClass: "option bg-green",
    on: {
      "click": _vm.showNewArticle
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "option-text"
  }, [_vm._v("发布话题")])]), _vm._v(" "), _c('Buttons', {
    staticClass: "option bg-yellow",
    on: {
      "click": _vm.showUserCenter
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "option-text"
  }, [_vm._v("个人中心")])]), _vm._v(" "), _c('Buttons', {
    staticClass: "option bg-orange",
    on: {
      "click": _vm.showAbout
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "option-text"
  }, [_vm._v("关于")])]), _vm._v(" "), _c('Buttons', {
    staticClass: "option bg-cyan",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logout-text"
  }, [_c('span', {
    staticClass: "optionText"
  }, [_vm._v("退出")])])])], 1), _vm._v(" "), _c('SkinColor')], 1), _vm._v(" "), _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hiddenAsideMenu
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-58fa3d70"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/AsideMenu/AsideMenu.vue
// module id = 331
// module chunks = 4